export const CURRENT_VERSION = '3.3';

export const CHANGELOG = [
  {
    version: '3.3',
    date: '2 novembre 2026',
    entries: [
      {
        icon: 'Layers',
        color: 'text-blue-600 bg-blue-50',
        scope: 'Couverture — Fonctionnelle',
        title: 'Ce que les tests couvrent, fonctionnalité par fonctionnalité',
        description: "La nouvelle page Couverture > Fonctionnelle découpe Argonos en domaines, fonctionnalités et capacités, et montre lesquelles ont au moins un test automatisé : taux global, taux sur les capacités P1, fonctionnalités sans aucun test, par domaine. La carte est un brouillon déduit des tests existants : les PO et les QA la corrigent sur place (criticité, version d'apparition, capacités manquantes ou hors périmètre, ajout ou suppression de fonctionnalités), la valident et en discutent. Chaque modification est signée et visible dans l'historique.",
      },
    ],
  },
  {
    version: '3.2',
    date: '22 octobre 2026',
    entries: [
      {
        icon: 'LayoutDashboard',
        color: 'text-slate-600 bg-slate-50',
        scope: 'Equipes — Backbone',
        title: "Les tests d'exploitation de l'équipe Backbone",
        description: "Les tests d'infrastructure joués à la fin des déploiements Proxmox (ta02 pour la 26.1, ta01 pour la 26.2) ont maintenant leur page d'équipe, avec les mêmes outils que les autres : détail des tests, tendance, analyse IA, cause racine et suite vérifiée. Ils figurent aussi dans la Vue globale. Quand un déploiement casse avant l'étape de tests, c'est le dernier run qui a vraiment joué la suite qui s'affiche, avec sa date.",
      },
    ],
  },
  {
    version: '3.1',
    date: '8 octobre 2026',
    entries: [
      {
        icon: 'Crosshair',
        color: 'text-teal-600 bg-teal-50',
        scope: 'Log Intelligence',
        title: "L'historique d'une erreur ne mélange plus les environnements",
        description: "Une erreur ouverte depuis l'onglet qa4 affichait aussi ses occurrences de qa1, qa2 et qa3, alors que la liste, les compteurs et la colonne « Dernière occurrence » ne parlaient que de qa4. Ce n'était pas marginal : 261 des 1202 signatures vivent sur plusieurs environnements, et vu depuis qa1 c'est 70 % d'entre elles — un exemple affichait 42 lignes dont 7 seulement appartenaient à l'environnement regardé. L'historique, le graphique et les campagnes de test suivent maintenant l'environnement choisi, et l'intitulé le nomme au lieu d'annoncer « toutes envs ». La période, elle, reste volontairement non appliquée : c'est l'historique complet qu'on vient y chercher.",
      },
    ],
  },
  {
    version: '3.0',
    date: '7 octobre 2026',
    entries: [
      {
        icon: 'Layers',
        color: 'text-purple-600 bg-purple-50',
        scope: 'Log Intelligence',
        title: 'La cause sous-jacente d’une erreur',
        description: "Beaucoup d’erreurs .NET en enveloppent une autre, et c’est la plus profonde qui dit quelque chose. La plus fréquente du catalogue annonçait « Failed to call processes RPC services with RpcMethodException exception » — un message qui nomme sa propre exception — alors que la cause réelle, deux niveaux plus bas, était un refus de permission réseau. Ces niveaux étaient reçus puis jetés à la collecte ; le détail d’une erreur les affiche maintenant, du plus proche au plus profond. Mesuré sur 48 h : 1,4 % des lignes de log, mais 24 % des erreurs distinctes. Une erreur cataloguée avant ce changement affiche « inconnue » jusqu’à sa prochaine occurrence, et non « aucune » : les deux ne veulent pas dire la même chose.",
      },
    ],
  },
  {
    version: '2.9',
    date: '7 octobre 2026',
    entries: [
      {
        icon: 'FileSearch',
        color: 'text-sky-600 bg-sky-50',
        scope: 'Log Intelligence',
        title: 'Les TraceId ouvrent les logs applicatifs',
        description: "Le détail d'une erreur affichait ses TraceId sans pouvoir rien en faire : il fallait les recopier dans Kibana. Ils sont maintenant cliquables et ouvrent, dans l'écran, toutes les lignes de log qui portent cette trace — l'erreur cataloguée, mais aussi ce qui l'a précédée et suivie dans la même requête. L'authentification Elasticsearch est celle déjà utilisée par ReadyAPI, demandée une fois par environnement. 73 % des occurrences récentes portent un TraceId ; pour les autres, l'écran dit que le log applicatif n'en portait pas, plutôt que d'afficher un lien mort.",
      },
      {
        icon: 'ShieldCheck',
        color: 'text-emerald-600 bg-emerald-50',
        scope: 'ReadyAPI',
        title: "La recherche de logs ne se trompe plus d'environnement",
        description: "La recherche par TraceId ne connaissait que qa1 et qa3, et ramenait silencieusement toute autre zone à qa1 : une trace de qa2 ou qa4 allait donc chercher dans les logs de qa1 et renvoyait un résultat vide, ou appartenant à un autre environnement, sans rien signaler. Les quatre environnements sont maintenant gérés, et une zone inconnue est refusée avec un message explicite au lieu d'un repli muet. Sur le catalogue Log Intelligence, 55 % des TraceId sont sur qa2 ou qa4.",
      },
    ],
  },
  {
    version: '2.8',
    date: '5 octobre 2026',
    entries: [
      {
        icon: 'Rocket',
        color: 'text-indigo-600 bg-indigo-50',
        scope: 'Releases',
        title: 'Une page pour suivre la release 26.2.0',
        description: "Le menu Releases propose désormais 26.2.0 : la même vue que 26.1.1 (tickets non fermés par statut, priorité et squad, évolution quotidienne), appliquée aux tickets dont le planned release contient 26.2.0.",
      },
    ],
  },
  {
    version: '2.7',
    date: '28 septembre 2026',
    entries: [
      {
        icon: 'Layers',
        color: 'text-blue-600 bg-blue-50',
        scope: 'Equipes — Innovation',
        title: 'Nouvelle suite RF Workplace Browser',
        description: "Les résultats des tests Browser de Workplace (pipeline 685) apparaissent désormais sur la page Innovation et dans la carte de la squad sur la Vue globale, à côté de la suite Workplace API.",
      },
      {
        icon: 'Clock',
        color: 'text-amber-600 bg-amber-50',
        scope: 'Log Intelligence',
        title: 'Une colonne « Dernière occurrence », triable',
        description: "La liste ne disait que depuis quand une erreur était connue. Impossible d'y repérer celles qui tombent encore aujourd'hui sans être nouvelles — et elles sont 81 sur les 110 vues aujourd'hui. Une colonne donne maintenant la date de la dernière erreur réelle, triable comme les autres, et le tri par défaut s'y appuie. Elle suit l'environnement et la période filtrés : sur les 136 signatures présentes sur plusieurs environnements, 129 ont une dernière erreur différente selon l'environnement, et afficher celle d'un autre aurait été faux. Elle montre aussi l'inverse : un tiers du catalogue n'a plus rien produit depuis plus d'une semaine.",
      },
    ],
  },
  {
    version: '2.6',
    date: '25 septembre 2026',
    entries: [
      {
        icon: 'CheckCircle',
        color: 'text-green-600 bg-green-50',
        scope: 'Equipes',
        title: 'Marquer le run d\'une suite comme analysé',
        description: "Chaque carte de suite, Robot Framework comme ReadyAPI, a désormais un bouton « Marquer ce run comme analysé » : la carte affiche ensuite qui l'a analysé et quand, et un nouveau run repart non analysé. Un run sans aucun échec, ou dont chaque échec a déjà un bug ouvert lié, est marqué analysé d'office, avec la date du run. Quand toutes les suites de la version sont analysées, un bandeau vert le signale sous les statistiques.",
      },
      {
        icon: 'ShieldCheck',
        color: 'text-emerald-600 bg-emerald-50',
        scope: 'Vue globale',
        title: 'Voir quelles squads ont revu leurs résultats',
        description: "Chaque carte squad indique combien de ses suites ont été analysées, y compris d'office, et passe au vert avec le nom des personnes qui les ont analysées quand toutes l'ont été : plus besoin d'ouvrir chaque page d'équipe pour savoir où en est la revue du jour.",
      },
    ],
  },
  {
    version: '2.5',
    date: '17 septembre 2026',
    entries: [
      {
        icon: 'TrendingUp',
        color: 'text-rose-600 bg-rose-50',
        scope: 'Log Intelligence',
        title: 'Plus de « pic » sur une erreur qui vient d\'apparaître',
        description: "Le badge 📈 apparaissait sur des erreurs vues pour la première fois. La règle le voulait — sans historique, elle bascule sur un seuil absolu de 5 occurrences — mais « pic » signifie « plus que d'habitude », et une erreur qui vient d'apparaître n'a pas d'habitude. Le badge est désormais réservé aux vraies augmentations et aux résurgences ; pour une nouveauté, « Nouveau » le dit déjà et le volume est dans la colonne d'à côté. La légende décrit maintenant les deux cas au lieu du seul rapport à la moyenne.",
      },
    ],
  },
  {
    version: '2.4',
    date: '15 septembre 2026',
    entries: [
      {
        icon: 'Crosshair',
        color: 'text-violet-600 bg-violet-50',
        scope: 'Log Intelligence',
        title: 'La pull request qui touche le code en cause',
        description: "Un déploiement de release embarque souvent plusieurs dizaines de pull requests d'un coup : une fenêtre de 18 h avec un seul déploiement en contenait 57. La pile d'appel d'une erreur .NET indique le fichier source exact d'où elle est levée ; l'écran le compare aux fichiers modifiés par chaque PR. Quand l'une d'elles modifie ce fichier, elle est nommée avec la raison — vérifiable en ouvrant la PR. Quand seuls le répertoire ou le projet correspondent, l'écran le dit comme tel : un filtre (2 PR retenues sur 25 en moyenne), pas une désignation. Au-delà de dix PR sans correspondance, c'est leur nombre qui s'affiche plutôt qu'une liste que personne ne lira.",
      },
      {
        icon: 'FlaskConical',
        color: 'text-teal-600 bg-teal-50',
        scope: 'Log Intelligence',
        title: 'Quels tests tournaient quand l\'erreur est apparue',
        description: "Le détail d'une erreur indique désormais les campagnes de test en cours au moment où elle est apparue — la suite, le pipeline, la branche testée, et si la campagne était au vert. Et dans l'autre sens, une section « Campagnes de test de la période » en bas de page se déplie pour montrer, campagne par campagne, les erreurs tombées pendant son exécution : la question du matin devant un rapport rouge, qui se réglait jusqu'ici à la main dans Kibana. Mesuré sur 36 h réelles : une erreur apparaît pendant une campagne 2 fois plus souvent que le hasard, sur qa3 comme sur qa4. C'est un repère temporel qui dit quel test rejouer, pas une cause : des erreurs apparaissent aussi pendant des campagnes qui passent.",
      },
      {
        icon: 'ExternalLink',
        color: 'text-blue-600 bg-blue-50',
        scope: 'Log Intelligence',
        title: 'Les pull requests cliquables dans le détail',
        description: "Le panneau de droite listait les numéros de PR sans lien : il fallait les recopier pour les ouvrir. Ils sont maintenant cliquables, et celles qui touchent le code de l'erreur affichent la raison. Quand il n'y en a aucune, l'écran dit laquelle des trois situations c'est — pas encore analysée, aucune livraison dans la fenêtre, ou des livraisons dont aucune pull request n'a pu être tirée — au lieu d'un message qui annonçait à tort une fonctionnalité non implémentée.",
      },
      {
        icon: 'CalendarRange',
        color: 'text-sky-600 bg-sky-50',
        scope: 'Log Intelligence',
        title: "L'intervalle part de la dernière collecte sans l'erreur",
        description: "Les environnements QA tournent la nuit, une nuit en 26.1, la suivante en 26.2 : l'erreur apparaît entre deux exécutions, et plusieurs déploiements ont pu avoir lieu entre-temps. L'intervalle examiné va désormais de la dernière collecte qui ne voyait pas l'erreur jusqu'à son apparition — tous les déploiements de cette fenêtre sont examinés, plus seulement le dernier. Quand il n'y en a aucun, l'écran le dit : ce n'est pas une régression de code.",
      },
      {
        icon: 'Clock',
        color: 'text-amber-600 bg-amber-50',
        scope: 'Log Intelligence',
        title: "L'heure de l'erreur, plus celle de la collecte",
        description: "Les lignes affichaient toutes 06:00, l'heure du passage automatique, et une erreur sur deux était datée du lendemain de sa première occurrence — impossible de remettre deux erreurs du même jour dans l'ordre. L'heure réelle est maintenant enregistrée et affichée. Pour les erreurs cataloguées avant ce changement, seul le jour est connu, et l'écran l'indique au lieu d'inventer une heure.",
      },
    ],
  },
  {
    version: '2.3',
    date: '14 septembre 2026',
    entries: [
      {
        icon: 'GitPullRequest',
        color: 'text-violet-600 bg-violet-50',
        scope: 'Log Intelligence',
        title: 'Ce qui a été livré juste avant une erreur nouvelle',
        description: "Déplier un problème affiche maintenant le déploiement qui a précédé son apparition, les composants qu'il a modifiés, et les pull requests qu'il embarquait — celles d'argonos comme celles de shared-devops, où vivent les ConfigMaps et les secrets. Un dépôt qui n'a pas bougé entre les deux versions est signalé comme tel : c'est une cause écartée.",
      },
      {
        icon: 'ShieldCheck',
        color: 'text-emerald-600 bg-emerald-50',
        scope: 'Log Intelligence',
        title: "Le texte ne promet pas plus que ce qu'il sait",
        description: "L'écran dit « livrées par ce déploiement », jamais « à l'origine de ». Sur le premier relevé réel, sept erreurs Cassandra se seraient vu attribuer une PR sur les entités du référentiel — uniquement parce qu'elle était la seule de l'intervalle. Quand un déploiement contient plus de huit PR, c'est leur nombre qui s'affiche plutôt qu'une sélection arbitraire.",
      },
    ],
  },
  {
    version: '2.2',
    date: 'Septembre 2026',
    entries: [
      {
        icon: 'Bug',
        color: 'text-red-600 bg-red-50',
        scope: 'Vue globale',
        title: 'La plateforme affichée reflète le run réel',
        description: "Le badge plateforme (QA1, QA3, val05, val9…) de la vue globale des tests était figé dans la configuration, sans lien avec l'environnement réellement utilisé par le dernier run. Il reflète désormais l'environnement du build, et affiche « N/A » tant qu'aucun run n'a encore été chargé.",
      },
    ],
  },
  {
    version: '2.1',
    date: 'Septembre 2026',
    entries: [
      {
        icon: 'Layers',
        color: 'text-teal-600 bg-teal-50',
        scope: 'Log Intelligence',
        title: 'Une ligne par problème, plus une par variante',
        description: "La page affichait une ligne par signature : sur qa4, une seule erreur Solr en occupait 922. Les signatures qui ne diffèrent que par une valeur (identifiant de collection, durée, jeton de connexion) sont désormais regroupées sous une même ligne, avec un badge « n variantes ». Un clic déplie le détail de chacune, et le panneau habituel s'ouvre depuis n'importe laquelle.",
      },
      {
        icon: 'Fingerprint',
        color: 'text-amber-600 bg-amber-50',
        scope: 'Log Intelligence',
        title: 'Les doublons corrigés à la racine',
        description: "Un identifiant collé à un préfixe (« universe_ » suivi d'un UUID) échappait au nettoyage, et chaque collection créait donc sa propre ligne. Même chose pour les noms de dossier Grafana et les valeurs masquées par le logger. Sur la période complète, l'écran passe de plus de 2000 lignes à moins de 400 pour exactement les mêmes erreurs.",
      },
      {
        icon: 'Bot',
        color: 'text-indigo-600 bg-indigo-50',
        scope: 'Log Intelligence',
        title: 'Un seul titre et une seule sévérité par problème',
        description: "L'IA reformulait le titre à chaque signature : une même erreur Solr portait jusqu'à 393 libellés différents, ce qui donnait l'impression de centaines de problèmes distincts. Chaque problème affiche maintenant un titre unique, la sévérité la plus grave de ses variantes, et le type d'exception juste en dessous — deux lignes qui se ressemblent ne sont plus confondues.",
      },
      {
        icon: 'LayoutDashboard',
        color: 'text-slate-600 bg-slate-50',
        scope: 'Log Intelligence',
        title: 'Tableau élargi, colonnes enfin lisibles',
        description: "La page est plus large et le nom du service n'est plus tronqué. Les colonnes sont dimensionnées en proportion de l'écran, ce qui supprime définitivement le défilement horizontal, quelle que soit la taille de la fenêtre.",
      },
      {
        icon: 'FileSearch',
        color: 'text-purple-600 bg-purple-50',
        scope: 'Log Intelligence',
        title: 'Plus de limite silencieuse à 500 signatures',
        description: "La page ne chargeait que les 500 signatures les plus récentes, sans le dire : avec 2070 au catalogue, une partie des erreurs n'apparaissait jamais. Le regroupement est calculé sur la totalité de la période et de l'environnement choisis.",
      },
      {
        icon: 'CheckCircle',
        color: 'text-emerald-600 bg-emerald-50',
        scope: 'Log Intelligence',
        title: 'Un envoi Slack raté n\'est plus annoncé comme une panne de collecte',
        description: "Quand la notification Slack échouait, la page affichait « le dernier run de collecte a échoué » alors que les logs avaient été lus correctement. Les deux étapes sont désormais distinctes : une collecte réussie reste une collecte réussie, et seul un vrai échec de lecture est signalé comme tel.",
      },
    ],
  },
  {
    version: '2.0',
    date: 'Septembre 2026',
    entries: [
      {
        icon: 'ScanSearch',
        color: 'text-teal-600 bg-teal-50',
        scope: 'Log Intelligence',
        title: 'Nouvelle page Log Intelligence',
        description: "Les erreurs des logs applicatifs Argonos (qa1 à qa4) deviennent une source de détection au lieu d'une pièce à conviction consultée après coup. Chaque exception est regroupée automatiquement en une signature unique, comptée par environnement et par jour, avec son historique — un onglet par environnement, la période de votre choix.",
      },
      {
        icon: 'Bot',
        color: 'text-indigo-600 bg-indigo-50',
        scope: 'Log Intelligence',
        title: 'Sévérité et catégorie proposées par l\'IA',
        description: "À sa première apparition, chaque signature reçoit un titre lisible, une sévérité (bloquant, majeur, mineur, bruit) et une catégorie, choisis dans une liste fixe — jamais inventés. Un badge « IA » distingue ce qui vient du modèle du texte brut remonté par Elasticsearch.",
      },
      {
        icon: 'Users',
        color: 'text-purple-600 bg-purple-50',
        scope: 'Log Intelligence',
        title: 'Assignation à une équipe et suivi du triage',
        description: "Assignez une signature à une squad, collez le numéro du bug Azure DevOps associé, et faites évoluer son statut (triée, connue, corrigée, muette…) depuis le panneau de détail. Mettre une signature en sourdine exige toujours une échéance : jamais de silence permanent.",
      },
      {
        icon: 'TrendingUp',
        color: 'text-red-600 bg-red-50',
        scope: 'Log Intelligence',
        title: 'Ce qui est nouveau ou en train d\'exploser saute aux yeux',
        description: "Les signatures apparues dans les deux derniers jours sont surlignées, et un pic est signalé quand une erreur dépasse trois fois sa moyenne des sept jours précédents — avec le détail au survol. Le tableau se trie sur n'importe quelle colonne.",
      },
      {
        icon: 'Fingerprint',
        color: 'text-amber-600 bg-amber-50',
        scope: 'Log Intelligence',
        title: 'Regroupement des erreurs nettement plus fiable',
        description: "Plusieurs valeurs qui changent à chaque occurrence (temps de réponse Solr, liste d'hôtes Cassandra, nom du composant ou du service planifié, identifiants courts) créaient une signature par occurrence : une même erreur apparaissait des dizaines de fois. Elles sont désormais neutralisées avant le regroupement.",
      },
      {
        icon: 'FileSearch',
        color: 'text-slate-600 bg-slate-50',
        scope: 'Log Intelligence',
        title: 'Du tableau jusqu\'au log dans Kibana',
        description: "Le panneau de détail affiche le message, la pile d'appel, la répartition des occurrences par environnement et par jour, et les TraceId associés à copier dans Kibana pour retrouver le log complet.",
      },
    ],
  },
  {
    version: '1.9',
    date: 'Août 2026',
    entries: [
      {
        icon: 'Clock',
        color: 'text-slate-600 bg-slate-50',
        title: 'Pourquoi les tests sont ignorés',
        description: "Les tests ignorés n'étaient qu'un compteur. Un nouveau bloc les regroupe par motif — sur la vue globale comme sur les pages d'équipe — et se déplie sur la liste des tests concernés. Les motifs viennent du message laissé par le test lui-même.",
      },
      {
        icon: 'Bug',
        color: 'text-red-600 bg-red-50',
        title: 'Tests ReadyAPI enfin comptés dans la vue globale',
        description: "Les pipelines ReadyAPI 26.2 étaient absents de la configuration de la vue globale : Data Exploration affichait 511 tests au lieu de 666. Les quatre squads concernées les comptent désormais, et leurs chiffres correspondent à ceux de la page d'équipe.",
      },
      {
        icon: 'BarChart2',
        color: 'text-amber-600 bg-amber-50',
        title: 'Comptage ReadyAPI cohérent',
        description: "Les tests dont le résultat n'était ni « passé » ni « échoué » (interrompu, non concluant) comptaient dans le total sans apparaître nulle part : le total ne correspondait plus à la somme passés + échecs + ignorés, et le taux de réussite baissait sans échec pour l'expliquer.",
      },
    ],
  },
  {
    version: '1.8',
    date: 'Août 2026',
    entries: [
      {
        icon: 'FileSearch',
        color: 'text-blue-600 bg-blue-50',
        title: 'Rapport et log Robot Framework en un clic',
        description: "Ouvrez le rapport ou le log Robot Framework d'un build directement depuis sa carte de suite, sans télécharger l'artefact Azure DevOps à la main. Depuis le rapport, un clic sur un test amène au bon endroit du log.",
      },
      {
        icon: 'Database',
        color: 'text-purple-600 bg-purple-50',
        title: 'Résultats de tests complets',
        description: "Les vues détail ne remontaient que les 200 premiers résultats d'un run, sans le signaler : un run de 465 tests en affichait 200. Tous les résultats sont désormais récupérés, ce qui corrige aussi les filtres, le tri et l'analyse IA des échecs.",
      },
      {
        icon: 'BarChart2',
        color: 'text-amber-600 bg-amber-50',
        title: 'Taux de réussite fiable sur les tests ignorés',
        description: "Les tests SKIP de Robot Framework étaient comptés comme des réussites, ce qui faisait monter le taux quand une suite en skippait beaucoup. Ils sont maintenant décomptés à part et exclus du calcul.",
      },
    ],
  },
  {
    version: '1.7',
    date: 'Juillet 2026',
    entries: [
      {
        icon: 'Bug',
        color: 'text-red-600 bg-red-50',
        title: 'Liaison de bugs simplifiée',
        description: "Rattachez un bug existant à un test en échec en tapant simplement son numéro, ou liez plusieurs tests au même bug d'un coup via la sélection multiple. Fonctionne même sans Test Case ADO associé.",
      },
      {
        icon: 'Clock',
        color: 'text-teal-600 bg-teal-50',
        title: 'Navigation temporelle sur la timeline',
        description: "Cliquez sur n'importe quelle barre de la timeline pour afficher les résultats de ce jour précis. La barre sélectionnée s'assombrit et un badge date apparaît. Re-cliquez pour revenir aux résultats du dernier jour.",
      },
    ],
  },
  {
    version: '1.6',
    date: 'Juillet 2026',
    entries: [
      {
        icon: 'Layers',
        color: 'text-blue-600 bg-blue-50',
        title: 'Résultats par version dans les pages équipes',
        description: "Les pages d'équipe permettent désormais de consulter les résultats de tests par version (26.1, 26.2…). La version sélectionnée dans la vue globale est automatiquement appliquée à l'ouverture.",
      },
      {
        icon: 'BarChart2',
        color: 'text-indigo-600 bg-indigo-50',
        title: 'Root cause classifiée par version',
        description: "Les causes racines sont maintenant associées à une version (26.1, 26.2…). La vue globale affiche un graphique de répartition Bug/Test/Env par version pour comparer les releases.",
      },
    ],
  },
  {
    version: '1.5',
    date: 'Juin 2026',
    entries: [
      {
        icon: 'Wrench',
        color: 'text-orange-600 bg-orange-50',
        title: 'Root cause par lot',
        description: "Cochez plusieurs tests KO et assignez-leur une cause racine en un seul clic via la barre flottante. Disponible sur toutes les pages équipes.",
      },
      {
        icon: 'BarChart2',
        color: 'text-violet-600 bg-violet-50',
        title: 'Root cause par équipe',
        description: "La vue globale affiche la répartition Bug/Test/Env par suite de tests pour identifier rapidement quelles équipes cumulent quels types de problèmes.",
      },
      {
        icon: 'FileSearch',
        color: 'text-amber-600 bg-amber-50',
        title: 'Dette d\'analyse visible',
        description: "Un indicateur affiche combien de tests KO des builds actuels n'ont pas encore été analysés, pour ne rien laisser passer.",
      },
      {
        icon: 'Zap',
        color: 'text-cyan-600 bg-cyan-50',
        title: 'Évolution root cause en %',
        description: "Le graphique d'évolution quotidienne passe en pourcentages pour comparer les journées indépendamment du volume analysé.",
      },
    ],
  },
  {
    version: '1.4',
    date: 'Juin 2026',
    entries: [
      {
        icon: 'LayoutDashboard',
        color: 'text-blue-600 bg-blue-50',
        title: 'Vue générale repensée',
        description: "La vue globale affiche maintenant un résumé des résultats de chaque équipe : tests passés/échoués, taux de réussite, statut pipeline en temps réel.",
      },
      {
        icon: 'BarChart2',
        color: 'text-violet-600 bg-violet-50',
        title: 'Tableau comparatif entre squads',
        description: "Un tableau synthétique compare toutes les équipes côte à côte : volume de tests, taux de réussite, tendances — pour identifier rapidement les squads en difficulté.",
      },
      {
        icon: 'Layers',
        color: 'text-cyan-600 bg-cyan-50',
        title: 'Pipelines RF splittés par suite',
        description: "Les pipelines Robot Framework sont maintenant découpés par testsuite, permettant de relancer ou consulter chaque suite de manière indépendante.",
      },
      {
        icon: 'Bot',
        color: 'text-indigo-600 bg-indigo-50',
        title: 'Analyse IA des suites de tests',
        description: "Analysez une suite en échec en un clic depuis la page squad. L'IA regroupe les erreurs par cluster, identifie les causes racines et propose un ordre de traitement.",
      },
      {
        icon: 'HardDrive',
        color: 'text-slate-600 bg-slate-50',
        title: 'Cache des analyses IA (1h)',
        description: "Les résultats d'analyse sont conservés 1 heure en cache local. Relancez uniquement si nécessaire, les résultats précédents restent accessibles instantanément.",
      },
      {
        icon: 'Sparkles',
        color: 'text-purple-600 bg-purple-50',
        title: 'Refonte des panneaux d\'analyse IA',
        description: "Les panneaux d'analyse (suite et test unitaire) ont été redesignés : header gradient, animation slide-in, cards structurées avec hypothèses et logs.",
      },
      {
        icon: 'CheckCircle',
        color: 'text-green-600 bg-green-50',
        title: 'Marquer Non reproduit → statut Passed',
        description: "Marquer un test comme non reproduit met maintenant automatiquement son statut à Passed. Le test sort de la liste des échecs sans nécessiter une nouvelle exécution.",
      },
      {
        icon: 'XCircle',
        color: 'text-orange-600 bg-orange-50',
        title: '"Marquer Non reproduit" : bouton toujours visible',
        description: "Le bouton reste visible même quand des bugs sont déjà liés au test. Badge 'Non reproduit' et liste des bugs s'affichent maintenant ensemble.",
      },
      {
        icon: 'FileSearch',
        color: 'text-red-600 bg-red-50',
        title: 'Root cause des tests KO + KPI',
        description: "Assignez une cause racine (régression, données, infra…) à chaque test échoué. La vue générale agrège ces causes en KPI pour suivre les tendances.",
      },
      {
        icon: 'StickyNote',
        color: 'text-yellow-600 bg-yellow-50',
        title: 'Note libre sur la root cause',
        description: "Ajoutez une note textuelle libre en complément de la cause racine pour documenter le contexte ou les actions de suivi.",
      },
      {
        icon: 'Clock',
        color: 'text-teal-600 bg-teal-50',
        title: 'Timeline : durée configurable',
        description: "Choisissez la fenêtre temporelle des timelines directement dans l'interface : 7 jours, 14 jours ou 21 jours.",
      },
      {
        icon: 'Bug',
        color: 'text-pink-600 bg-pink-50',
        title: 'Modale des bugs améliorée',
        description: "La modale de consultation des bugs liés à un test a été enrichie : meilleure présentation, liens directs vers Azure DevOps.",
      },
      {
        icon: 'MessageSquare',
        color: 'text-green-600 bg-green-50',
        title: 'Notifications Slack améliorées',
        description: "Les messages Slack envoyés lors d'échecs de tests ont été enrichis avec plus de contexte et un meilleur formatage des blocs.",
      },
    ],
  },
];
